module.exports = __webpack_public_path__ + "static/media/score.b115c9df.svg";